
(() => {
  const KEY = 'sa_cart_reminder_closed';

  const pluralWord = (data, count) => {
    let cat = 'other';
    try {
      const lang = document.documentElement.lang || 'en';
      cat = new Intl.PluralRules(lang).select(count);
    } catch (e) { cat = count === 1 ? 'one' : 'other'; }
    const key = 'word' + cat.charAt(0).toUpperCase() + cat.slice(1);
    return data[key] || data.wordOther || '';
  };

  class CartReminder extends HTMLElement {
    connectedCallback() {
      this.closeBtn = this.querySelector('[data-home-cart-reminder-close]');
      this.textBox = this.querySelector('.homeCartReminder__text');
      // Лічильник на значку: у новому вигляді це справжній вузол, а не
      // псевдоелемент із `attr(data-cart-quantity)`, тож його треба
      // перемальовувати руками. `cart-status.js` теж його чіпає через
      // [data-cart-count] - обидва пишуть те саме число.
      this.badge = this.querySelector('.homeCartReminder__badge');
      this.closeBtn?.addEventListener('click', () => {
        this.hidden = true;
        try { sessionStorage.setItem(KEY, '1'); } catch (e) {  }
      });

      this.syncTop();
      window.addEventListener('resize', () => this.syncTop());
      window.addEventListener('scroll', () => this.syncTop(), { passive: true });

      this.unsubscribe = window.PubSub?.subscribe(window.EVENTS?.cartUpdate, ({ cart }) => {
        if (cart) this.render(cart.item_count, cart.total_price);
      });
    }

    syncTop() {
      const header = document.querySelector('.shopify-section-group-header-group')
                  || document.querySelector('site-header');
      const bottom = header ? Math.round(header.getBoundingClientRect().bottom) : 0;
      document.documentElement.style.setProperty('--home-cart-reminder-top', `${Math.max(0, bottom)}px`);
    }

    render(count, totalCents) {
      if (!this.textBox) return;
      let закрито = false;
      try { закрито = sessionStorage.getItem(KEY) === '1'; } catch (e) {  }
      if (!count) { this.hidden = true; return; }

      const word = pluralWord(this.dataset, count);
      const money = window.ThemeUtils?.formatMoney
        ? window.ThemeUtils.formatMoney(totalCents)
        : (totalCents / 100).toFixed(2);
      this.textBox.textContent = (this.dataset.template || '')
        .replace('@@N@@', count).replace('@@W@@', word || '').replace('@@S@@', money);
      this.setAttribute('data-cart-quantity', String(count));
      if (this.badge) {
        this.badge.textContent = count;
        this.badge.toggleAttribute('hidden', !count);
      }
      this.hidden = закрито;
    }
  }

  if (!customElements.get('cart-reminder')) customElements.define('cart-reminder', CartReminder);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-home-cart-reminder]').forEach((el) => {
      if (el.__reminderReady) return;
      el.__reminderReady = true;
      Object.setPrototypeOf(el, CartReminder.prototype);
      el.connectedCallback();
    });
  });
})();
